import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Navigation from './../../Navigation';
import * as actionsLogin from './../../../data/login/actions.js';
import Timer from './../../Timer';
import TokenGuard from './../../TokenGuard';
import { login } from './../../../settings/settings';
import { httpStatus, STAFFID } from './../../../data/constants/';
import { logout } from '../../../data/login/productionActions';

const MainLayout = props => {
  const [staff, setStaff] = useState({})

  useEffect(() => {
    const staffId = sessionStorage.getItem(STAFFID);
    if (staffId) {
      props.getUserInformation(staffId).then((response) => {
        const responseData = response.data;
        if (responseData.status && responseData.status === httpStatus.UNAUTHORIZED) {
          logout('/login');
          // Preserve language preference
          const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
          sessionStorage.clear();
          // Restore language preference
          if (tempLng) {
            localStorage.setItem('lng', tempLng);
            sessionStorage.setItem('lng', tempLng);
          }
        } else {
          setStaff(response.data)
        }
      }).catch((error) => {
        logout('/login');
        // Preserve language preference
        const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
        sessionStorage.clear();
        // Restore language preference
        if (tempLng) {
          localStorage.setItem('lng', tempLng);
          sessionStorage.setItem('lng', tempLng);
        }
      });
    }
  },[])

  return (
    <TokenGuard redirect={props.redirect}>
      <Timer
        waitingTime={login.maxIdleTime}
        onTimeout={props.expireSession}
      >
        <main>
          <Navigation
            user={props.user}
            logout={props.logout}
            staff={staff}
          />
          {props.children}
        </main>
      </Timer>
    </TokenGuard>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  expireSession: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  getUserInformation: PropTypes.func.isRequired,
  staff: PropTypes.object.isRequired
};

MainLayout.defaultProps = {
  children: {},
  expireSession: () => {},
  logout: () => {},
  getUserInformation: () => {},
  user: {},
  staff: {}
};

const mapDispatchToProps = dispatch => ({
  expireSession: () => dispatch(actionsLogin.default.expireSession()),
  logout: path => dispatch(actionsLogin.default.logout(path)),
  redirect: path => dispatch(actionsLogin.default.logout(path)),
  getUserInformation: staffId =>
    dispatch(actionsLogin.default.getUserInformation(staffId))
});

const mapStateToProps = state => ({ ...state.login });

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
